import { render, staticRenderFns } from "./ShopThankYou.vue?vue&type=template&id=9c7fb364&scoped=true&"
import script from "./ShopThankYou.vue?vue&type=script&lang=js&"
export * from "./ShopThankYou.vue?vue&type=script&lang=js&"
import style0 from "./ShopThankYou.vue?vue&type=style&index=0&id=9c7fb364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7fb364",
  null
  
)

export default component.exports